import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translations from './translations'

const { en, fr } = translations

// Initialize i18n package
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallBackLng: 'fr',
    resources: {
      en: { translation: en },
      fr: { translation: fr },
    },
  })

if (i18n.language !== 'fr' && i18n.language !== 'fr-FR' && i18n.language !== 'fr-fr')
  i18n.changeLanguage('en')

export const setCurrentLanguage = async (lang, noReload) => {
  lang = lang.toLowerCase()
  if (!['en', 'fr'].includes(lang)) return

  if (lang === getCurrentLanguage()) return

  await i18n.changeLanguage(lang)
  document.documentElement.setAttribute('lang', lang)

  if (noReload) return
  setTimeout(() => window.location.reload(), 300)
}

export const getCurrentLanguage = () => {
  const currentLanguage = i18n.language.includes('-')
    ? i18n.language.split('-')[0]
    : i18n.language

  // Return french as default if not french or english
  if (!['en', 'fr'].includes(currentLanguage)) return 'fr'
  return currentLanguage
}

// Main function used for translation
export const t = (...args) => i18n.t(...args)
